export default "__VITE_ASSET__D5LpD$vV__"